import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateProductionRecipeMutationVariables = Types.Exact<{
  input: Types.CreateProductionRecipeInput;
}>;


export type CreateProductionRecipeMutation = { __typename?: 'Mutation', createProductionRecipe: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateProductionRecipeWithVariationMutationVariables = Types.Exact<{
  input: Types.CreateProductionRecipeWithVariationInput;
}>;


export type CreateProductionRecipeWithVariationMutation = { __typename?: 'Mutation', createProductionRecipeWithVariation: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionRecipeMutationVariables = Types.Exact<{
  input: Types.ActivateProductionRecipeInput;
}>;


export type ActivateProductionRecipeMutation = { __typename?: 'Mutation', activateProductionRecipe: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateProductionRecipeMutationVariables = Types.Exact<{
  input: Types.InactivateProductionRecipeInput;
}>;


export type InactivateProductionRecipeMutation = { __typename?: 'Mutation', inactivateProductionRecipe: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionRecipeMutationVariables = Types.Exact<{
  input: Types.DeleteProductionRecipeInput;
}>;


export type DeleteProductionRecipeMutation = { __typename?: 'Mutation', deleteProductionRecipe: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, linkingRecipes?: Array<{ __typename?: 'ProductionRecipeLinkingPair', productionRecipeId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, status: Types.ProductionRecipeStatus, linkingVariationCount: number }> | null } };

export type DuplicateProductionRecipeMutationVariables = Types.Exact<{
  input: Types.DuplicateProductionRecipeInput;
}>;


export type DuplicateProductionRecipeMutation = { __typename?: 'Mutation', duplicateProductionRecipe: { __typename?: 'DuplicateProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RepointProductionRecipeLinksMutationVariables = Types.Exact<{
  input: Types.RepointProductionRecipeLinksInput;
}>;


export type RepointProductionRecipeLinksMutation = { __typename?: 'Mutation', repointProductionRecipeLinks: { __typename?: 'RepointProductionRecipeLinksPayload', results: Array<{ __typename?: 'RepointProductionRecipeLinksResult', productionRecipeId: string, status: Types.RepointProductionRecipeLinksStatus, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionRecipeVariationMutationVariables = Types.Exact<{
  input: Types.AddProductionRecipeVariationInput;
}>;


export type AddProductionRecipeVariationMutation = { __typename?: 'Mutation', addProductionRecipeVariation: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionRecipeVariationMutationVariables = Types.Exact<{
  input: Types.UpdateProductionRecipeVariationInput;
}>;


export type UpdateProductionRecipeVariationMutation = { __typename?: 'Mutation', updateProductionRecipeVariation: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchUpdateProductionRecipeVariationsMutationVariables = Types.Exact<{
  input: Types.BatchUpdateProductionRecipeVariationsInput;
}>;


export type BatchUpdateProductionRecipeVariationsMutation = { __typename?: 'Mutation', batchUpdateProductionRecipeVariations: { __typename?: 'BatchUpdateProductionRecipeVariationsPayload', results: Array<{ __typename?: 'BatchUpdateProductionRecipeVariationResult', productionRecipeId: string, variationId: string, status: Types.BatchUpdateProductionRecipeVariationStatus, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionRecipeVariationMutationVariables = Types.Exact<{
  input: Types.RemoveProductionRecipeVariationInput;
}>;


export type RemoveProductionRecipeVariationMutation = { __typename?: 'Mutation', removeProductionRecipeVariation: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetRecipeLaborSourceMutationVariables = Types.Exact<{
  input: Types.SetRecipeLaborSourceInput;
}>;


export type SetRecipeLaborSourceMutation = { __typename?: 'Mutation', setRecipeLaborSource: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionRecipeTypeMutationVariables = Types.Exact<{
  input: Types.SetProductionRecipeTypeInput;
}>;


export type SetProductionRecipeTypeMutation = { __typename?: 'Mutation', setProductionRecipeType: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, linkingRecipes?: Array<{ __typename?: 'ProductionRecipeLinkingPair', productionRecipeId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, status: Types.ProductionRecipeStatus, linkingVariationCount: number }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionRecipeTaskEventIdsMutationVariables = Types.Exact<{
  input: Types.SetRecipeTaskEventIdsInput;
}>;


export type SetProductionRecipeTaskEventIdsMutation = { __typename?: 'Mutation', setProductionRecipeTaskEventIds: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionRecipeMaterialVendorMutationVariables = Types.Exact<{
  input: Types.SetRecipeMaterialVendorInput;
}>;


export type SetProductionRecipeMaterialVendorMutation = { __typename?: 'Mutation', setProductionRecipeMaterialVendor: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionRecipeFlatRateCostMutationVariables = Types.Exact<{
  input: Types.SetRecipeFlatRateCostInput;
}>;


export type SetProductionRecipeFlatRateCostMutation = { __typename?: 'Mutation', setProductionRecipeFlatRateCost: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetProductionRecipeAdditionalCostEventIdsMutationVariables = Types.Exact<{
  input: Types.SetRecipeAdditionalCostEventIdsInput;
}>;


export type SetProductionRecipeAdditionalCostEventIdsMutation = { __typename?: 'Mutation', setRecipeAdditionalCostEventIds: { __typename?: 'ProductionRecipePayload', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ProductionRecipeVariationFieldValuesFieldsFragment = { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number };

export type ProductionRecipeVariationFieldsResultFieldsFragment = { __typename?: 'ProductionRecipeVariationFieldsResult', productionRecipeId: string, variationId: string, status: Types.ProductionRecipeVariationFieldsStatus, variation?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null, errors?: Array<{ __typename?: 'ProductionRecipeVariationFieldsError', code?: string | null, message: string, field?: Types.ProductionRecipeVariationField | null, min?: number | null, max?: number | null, changedFields?: Array<Types.ProductionRecipeVariationField> | null, customerId?: string | null, customerGroupId?: string | null, componentsPerPotSum?: number | null, saved?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null, otherVariation?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null }> | null };

export type UpdateProductionRecipeVariationFieldsMutationVariables = Types.Exact<{
  input: Types.UpdateProductionRecipeVariationFieldsInput;
}>;


export type UpdateProductionRecipeVariationFieldsMutation = { __typename?: 'Mutation', updateProductionRecipeVariationFields: { __typename?: 'ProductionRecipeVariationFieldsResult', productionRecipeId: string, variationId: string, status: Types.ProductionRecipeVariationFieldsStatus, variation?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null, errors?: Array<{ __typename?: 'ProductionRecipeVariationFieldsError', code?: string | null, message: string, field?: Types.ProductionRecipeVariationField | null, min?: number | null, max?: number | null, changedFields?: Array<Types.ProductionRecipeVariationField> | null, customerId?: string | null, customerGroupId?: string | null, componentsPerPotSum?: number | null, saved?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null, otherVariation?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null }> | null } };

export type BatchUpdateProductionRecipeVariationFieldsMutationVariables = Types.Exact<{
  input: Types.BatchUpdateProductionRecipeVariationFieldsInput;
}>;


export type BatchUpdateProductionRecipeVariationFieldsMutation = { __typename?: 'Mutation', batchUpdateProductionRecipeVariationFields: { __typename?: 'BatchUpdateProductionRecipeVariationFieldsPayload', results: Array<{ __typename?: 'ProductionRecipeVariationFieldsResult', productionRecipeId: string, variationId: string, status: Types.ProductionRecipeVariationFieldsStatus, variation?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null, errors?: Array<{ __typename?: 'ProductionRecipeVariationFieldsError', code?: string | null, message: string, field?: Types.ProductionRecipeVariationField | null, min?: number | null, max?: number | null, changedFields?: Array<Types.ProductionRecipeVariationField> | null, customerId?: string | null, customerGroupId?: string | null, componentsPerPotSum?: number | null, saved?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null, otherVariation?: { __typename?: 'ProductionRecipeVariationFieldValues', variationId: string, startWeek?: number | null, endWeek?: number | null, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number } | null }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const ProductionRecipeVariationFieldValuesFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeVariationFieldValuesFields on ProductionRecipeVariationFieldValues {
  variationId
  startWeek
  endWeek
  customerId
  customerGroupId
  siteLocationId
  growWeeks
  plantsPerPot
  yield
}
    `, {"fragmentName":"ProductionRecipeVariationFieldValuesFields"});
export const ProductionRecipeVariationFieldsResultFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeVariationFieldsResultFields on ProductionRecipeVariationFieldsResult {
  productionRecipeId
  variationId
  status
  variation {
    ...ProductionRecipeVariationFieldValuesFields
  }
  errors {
    code
    message
    field
    min
    max
    changedFields
    saved {
      ...ProductionRecipeVariationFieldValuesFields
    }
    otherVariation {
      ...ProductionRecipeVariationFieldValuesFields
    }
    customerId
    customerGroupId
    componentsPerPotSum
  }
}
    fragment ProductionRecipeVariationFieldValuesFields on ProductionRecipeVariationFieldValues {
  variationId
  startWeek
  endWeek
  customerId
  customerGroupId
  siteLocationId
  growWeeks
  plantsPerPot
  yield
}`, {"fragmentName":"ProductionRecipeVariationFieldsResultFields"});
export const CreateProductionRecipeDocument = new TypedDocumentString(`
    mutation CreateProductionRecipe($input: CreateProductionRecipeInput!) {
  createProductionRecipe(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const CreateProductionRecipeWithVariationDocument = new TypedDocumentString(`
    mutation CreateProductionRecipeWithVariation($input: CreateProductionRecipeWithVariationInput!) {
  createProductionRecipeWithVariation(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const ActivateProductionRecipeDocument = new TypedDocumentString(`
    mutation ActivateProductionRecipe($input: ActivateProductionRecipeInput!) {
  activateProductionRecipe(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const InactivateProductionRecipeDocument = new TypedDocumentString(`
    mutation InactivateProductionRecipe($input: InactivateProductionRecipeInput!) {
  inactivateProductionRecipe(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const DeleteProductionRecipeDocument = new TypedDocumentString(`
    mutation DeleteProductionRecipe($input: DeleteProductionRecipeInput!) {
  deleteProductionRecipe(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
    linkingRecipes {
      ...ProductionRecipeLinkingPairFields
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}
fragment ProductionRecipeLinkingPairFields on ProductionRecipeLinkingPair {
  productionRecipeId
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  status
  linkingVariationCount
}`);
export const DuplicateProductionRecipeDocument = new TypedDocumentString(`
    mutation DuplicateProductionRecipe($input: DuplicateProductionRecipeInput!) {
  duplicateProductionRecipe(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const RepointProductionRecipeLinksDocument = new TypedDocumentString(`
    mutation RepointProductionRecipeLinks($input: RepointProductionRecipeLinksInput!) {
  repointProductionRecipeLinks(input: $input) {
    results {
      productionRecipeId
      status
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const AddProductionRecipeVariationDocument = new TypedDocumentString(`
    mutation AddProductionRecipeVariation($input: AddProductionRecipeVariationInput!) {
  addProductionRecipeVariation(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const UpdateProductionRecipeVariationDocument = new TypedDocumentString(`
    mutation UpdateProductionRecipeVariation($input: UpdateProductionRecipeVariationInput!) {
  updateProductionRecipeVariation(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const BatchUpdateProductionRecipeVariationsDocument = new TypedDocumentString(`
    mutation BatchUpdateProductionRecipeVariations($input: BatchUpdateProductionRecipeVariationsInput!) {
  batchUpdateProductionRecipeVariations(input: $input) {
    results {
      productionRecipeId
      variationId
      status
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const RemoveProductionRecipeVariationDocument = new TypedDocumentString(`
    mutation RemoveProductionRecipeVariation($input: RemoveProductionRecipeVariationInput!) {
  removeProductionRecipeVariation(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const SetRecipeLaborSourceDocument = new TypedDocumentString(`
    mutation SetRecipeLaborSource($input: SetRecipeLaborSourceInput!) {
  setRecipeLaborSource(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const SetProductionRecipeTypeDocument = new TypedDocumentString(`
    mutation SetProductionRecipeType($input: SetProductionRecipeTypeInput!) {
  setProductionRecipeType(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    linkingRecipes {
      ...ProductionRecipeLinkingPairFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}
fragment ProductionRecipeLinkingPairFields on ProductionRecipeLinkingPair {
  productionRecipeId
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  status
  linkingVariationCount
}`);
export const SetProductionRecipeTaskEventIdsDocument = new TypedDocumentString(`
    mutation SetProductionRecipeTaskEventIds($input: SetRecipeTaskEventIdsInput!) {
  setProductionRecipeTaskEventIds(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const SetProductionRecipeMaterialVendorDocument = new TypedDocumentString(`
    mutation SetProductionRecipeMaterialVendor($input: SetRecipeMaterialVendorInput!) {
  setProductionRecipeMaterialVendor(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const SetProductionRecipeFlatRateCostDocument = new TypedDocumentString(`
    mutation SetProductionRecipeFlatRateCost($input: SetRecipeFlatRateCostInput!) {
  setProductionRecipeFlatRateCost(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const SetProductionRecipeAdditionalCostEventIdsDocument = new TypedDocumentString(`
    mutation SetProductionRecipeAdditionalCostEventIds($input: SetRecipeAdditionalCostEventIdsInput!) {
  setRecipeAdditionalCostEventIds(input: $input) {
    productionRecipe {
      ...ProductionRecipeDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`);
export const UpdateProductionRecipeVariationFieldsDocument = new TypedDocumentString(`
    mutation UpdateProductionRecipeVariationFields($input: UpdateProductionRecipeVariationFieldsInput!) {
  updateProductionRecipeVariationFields(input: $input) {
    ...ProductionRecipeVariationFieldsResultFields
  }
}
    fragment ProductionRecipeVariationFieldValuesFields on ProductionRecipeVariationFieldValues {
  variationId
  startWeek
  endWeek
  customerId
  customerGroupId
  siteLocationId
  growWeeks
  plantsPerPot
  yield
}
fragment ProductionRecipeVariationFieldsResultFields on ProductionRecipeVariationFieldsResult {
  productionRecipeId
  variationId
  status
  variation {
    ...ProductionRecipeVariationFieldValuesFields
  }
  errors {
    code
    message
    field
    min
    max
    changedFields
    saved {
      ...ProductionRecipeVariationFieldValuesFields
    }
    otherVariation {
      ...ProductionRecipeVariationFieldValuesFields
    }
    customerId
    customerGroupId
    componentsPerPotSum
  }
}`);
export const BatchUpdateProductionRecipeVariationFieldsDocument = new TypedDocumentString(`
    mutation BatchUpdateProductionRecipeVariationFields($input: BatchUpdateProductionRecipeVariationFieldsInput!) {
  batchUpdateProductionRecipeVariationFields(input: $input) {
    results {
      ...ProductionRecipeVariationFieldsResultFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionRecipeVariationFieldValuesFields on ProductionRecipeVariationFieldValues {
  variationId
  startWeek
  endWeek
  customerId
  customerGroupId
  siteLocationId
  growWeeks
  plantsPerPot
  yield
}
fragment ProductionRecipeVariationFieldsResultFields on ProductionRecipeVariationFieldsResult {
  productionRecipeId
  variationId
  status
  variation {
    ...ProductionRecipeVariationFieldValuesFields
  }
  errors {
    code
    message
    field
    min
    max
    changedFields
    saved {
      ...ProductionRecipeVariationFieldValuesFields
    }
    otherVariation {
      ...ProductionRecipeVariationFieldValuesFields
    }
    customerId
    customerGroupId
    componentsPerPotSum
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateProductionRecipe: build.mutation<CreateProductionRecipeMutation, CreateProductionRecipeMutationVariables>({
      query: (variables) => ({ document: CreateProductionRecipeDocument, variables })
    }),
    CreateProductionRecipeWithVariation: build.mutation<CreateProductionRecipeWithVariationMutation, CreateProductionRecipeWithVariationMutationVariables>({
      query: (variables) => ({ document: CreateProductionRecipeWithVariationDocument, variables })
    }),
    ActivateProductionRecipe: build.mutation<ActivateProductionRecipeMutation, ActivateProductionRecipeMutationVariables>({
      query: (variables) => ({ document: ActivateProductionRecipeDocument, variables })
    }),
    InactivateProductionRecipe: build.mutation<InactivateProductionRecipeMutation, InactivateProductionRecipeMutationVariables>({
      query: (variables) => ({ document: InactivateProductionRecipeDocument, variables })
    }),
    DeleteProductionRecipe: build.mutation<DeleteProductionRecipeMutation, DeleteProductionRecipeMutationVariables>({
      query: (variables) => ({ document: DeleteProductionRecipeDocument, variables })
    }),
    DuplicateProductionRecipe: build.mutation<DuplicateProductionRecipeMutation, DuplicateProductionRecipeMutationVariables>({
      query: (variables) => ({ document: DuplicateProductionRecipeDocument, variables })
    }),
    RepointProductionRecipeLinks: build.mutation<RepointProductionRecipeLinksMutation, RepointProductionRecipeLinksMutationVariables>({
      query: (variables) => ({ document: RepointProductionRecipeLinksDocument, variables })
    }),
    AddProductionRecipeVariation: build.mutation<AddProductionRecipeVariationMutation, AddProductionRecipeVariationMutationVariables>({
      query: (variables) => ({ document: AddProductionRecipeVariationDocument, variables })
    }),
    UpdateProductionRecipeVariation: build.mutation<UpdateProductionRecipeVariationMutation, UpdateProductionRecipeVariationMutationVariables>({
      query: (variables) => ({ document: UpdateProductionRecipeVariationDocument, variables })
    }),
    BatchUpdateProductionRecipeVariations: build.mutation<BatchUpdateProductionRecipeVariationsMutation, BatchUpdateProductionRecipeVariationsMutationVariables>({
      query: (variables) => ({ document: BatchUpdateProductionRecipeVariationsDocument, variables })
    }),
    RemoveProductionRecipeVariation: build.mutation<RemoveProductionRecipeVariationMutation, RemoveProductionRecipeVariationMutationVariables>({
      query: (variables) => ({ document: RemoveProductionRecipeVariationDocument, variables })
    }),
    SetRecipeLaborSource: build.mutation<SetRecipeLaborSourceMutation, SetRecipeLaborSourceMutationVariables>({
      query: (variables) => ({ document: SetRecipeLaborSourceDocument, variables })
    }),
    SetProductionRecipeType: build.mutation<SetProductionRecipeTypeMutation, SetProductionRecipeTypeMutationVariables>({
      query: (variables) => ({ document: SetProductionRecipeTypeDocument, variables })
    }),
    SetProductionRecipeTaskEventIds: build.mutation<SetProductionRecipeTaskEventIdsMutation, SetProductionRecipeTaskEventIdsMutationVariables>({
      query: (variables) => ({ document: SetProductionRecipeTaskEventIdsDocument, variables })
    }),
    SetProductionRecipeMaterialVendor: build.mutation<SetProductionRecipeMaterialVendorMutation, SetProductionRecipeMaterialVendorMutationVariables>({
      query: (variables) => ({ document: SetProductionRecipeMaterialVendorDocument, variables })
    }),
    SetProductionRecipeFlatRateCost: build.mutation<SetProductionRecipeFlatRateCostMutation, SetProductionRecipeFlatRateCostMutationVariables>({
      query: (variables) => ({ document: SetProductionRecipeFlatRateCostDocument, variables })
    }),
    SetProductionRecipeAdditionalCostEventIds: build.mutation<SetProductionRecipeAdditionalCostEventIdsMutation, SetProductionRecipeAdditionalCostEventIdsMutationVariables>({
      query: (variables) => ({ document: SetProductionRecipeAdditionalCostEventIdsDocument, variables })
    }),
    UpdateProductionRecipeVariationFields: build.mutation<UpdateProductionRecipeVariationFieldsMutation, UpdateProductionRecipeVariationFieldsMutationVariables>({
      query: (variables) => ({ document: UpdateProductionRecipeVariationFieldsDocument, variables })
    }),
    BatchUpdateProductionRecipeVariationFields: build.mutation<BatchUpdateProductionRecipeVariationFieldsMutation, BatchUpdateProductionRecipeVariationFieldsMutationVariables>({
      query: (variables) => ({ document: BatchUpdateProductionRecipeVariationFieldsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateProductionRecipeMutation, useCreateProductionRecipeWithVariationMutation, useActivateProductionRecipeMutation, useInactivateProductionRecipeMutation, useDeleteProductionRecipeMutation, useDuplicateProductionRecipeMutation, useRepointProductionRecipeLinksMutation, useAddProductionRecipeVariationMutation, useUpdateProductionRecipeVariationMutation, useBatchUpdateProductionRecipeVariationsMutation, useRemoveProductionRecipeVariationMutation, useSetRecipeLaborSourceMutation, useSetProductionRecipeTypeMutation, useSetProductionRecipeTaskEventIdsMutation, useSetProductionRecipeMaterialVendorMutation, useSetProductionRecipeFlatRateCostMutation, useSetProductionRecipeAdditionalCostEventIdsMutation, useUpdateProductionRecipeVariationFieldsMutation, useBatchUpdateProductionRecipeVariationFieldsMutation } = injectedRtkApi;
